import React, { useState, useEffect } from "react";
import Image from "../../Elements/Image/Image.tsx";
import Button from "../../Elements/Button/Button.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";
import { useParams } from "react-router-dom";
import { LinkToNewTab } from "../../Elements/Link/Link.js";

import "./UserConfirmation.scss";

const UserConfirmation = () => {
  const { getTextByKey, getLanguageCulture } = useContent();
  const params = useParams();
  const { addToast } = useToasts();
  const [expiredToken, setExpiredToken] = useState(false);
  const [emailToSend, setEmailToSend] = useState("");
  const [loading, setLoading] = useState(true);
  const ReSendConfirmation = async () => {
    setLoading(true);
    const parameters = {
      UserEmail: emailToSend,
      Culture: getLanguageCulture(),
    };
    const response = await apiRequest(
      "MailTemplaites",
      "NewUserConfirmation",
      parameters
    );

    if (response.status === "success") {
      if (response.data) {
        addToast(getTextByKey("send-mail-success-alert-confirmation"), {
          appearance: "success",
        });
      } else {
        addToast(getTextByKey("global-error-alert"), {
          appearance: "error",
        });
      }
    } else {
      addToast(getTextByKey("global-error-alert"), {
        appearance: "error",
      });
    }
    setLoading(false);
  };
  const DescryptTokenUserConfirmation = async () => {
    setLoading(true);
    const parameters = {
      token: params.token,
    };
    const response = await apiRequest(
      "Users",
      "DescryptTokenUserConfirmation",
      parameters
    );

    if (response.status === "success") {
      if (response.data) {
        if (response.data.status === "expired") {
          setExpiredToken(true);
          setEmailToSend(response.data.UserEmail);
        } else if (response.data.status === "no-token") {
          addToast(getTextByKey("global-error-alert"), {
            appearance: "error",
          });
        } else {
          setExpiredToken(false);
          setEmailToSend(response.data.UserEmail);
        }
      } else {
        addToast(getTextByKey("global-error-alert"), {
          appearance: "error",
        });
      }
    } else {
      addToast(getTextByKey("global-error-alert"), {
        appearance: "error",
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (params.token !== undefined) {
      DescryptTokenUserConfirmation();
    }
  }, [params.token]);

  return (
    <div className="full-page user-confirmation-full-page">
      <div className="page-container">
        <div className="title-page"></div>
        {!loading && emailToSend ? (
          <div className="main-page user-confirmation-main">
            {!expiredToken ? (
              <>
                <Image
                  name="confirmation-page/user-confirmation"
                  ext="svg"
                  alt=""
                  title=""
                />
                <h1>
                  {getTextByKey("registration-complete-title-confirmation")}
                </h1>
                <p>
                  {getTextByKey(
                    "email-authentication-success-text-confirmation"
                  )}
                </p>
                <div className="actions">
                  <LinkToNewTab page="home">
                    <Button>{getTextByKey("send-large-files")}</Button>
                  </LinkToNewTab>
                  <LinkToNewTab page={"user/profile/account"}>
                    <Button blank>
                      {getTextByKey("my-profile-page-confirmation")}
                    </Button>
                  </LinkToNewTab>
                </div>
              </>
            ) : (
              <div className="expired-token-confirmation-main">
                <Icon iconClass="no-forms-img" name="no-forms" xxxl="true" />
                <h2>{getTextByKey("expired-time-title-confirmation")}</h2>
                <p>{getTextByKey("expired-time-text-confirmation")}</p>
                {emailToSend && (
                  <>
                    <p>
                      {getTextByKey("expired-time-email-send-to-confirmation")}{" "}
                      {emailToSend}
                    </p>
                    <Button onClick={() => ReSendConfirmation()}>
                      {getTextByKey("resend-button-confirmation")}
                    </Button>
                  </>
                )}
              </div>
            )}
          </div>
        ) : loading && emailToSend ? (
          <div className="loading-blog-container">
            <LoadingImageElement />
          </div>
        ) : (
          !loading && (
            <div className="no-email">{getTextByKey("global-error-alert")}</div>
          )
        )}
      </div>
    </div>
  );
};

export default UserConfirmation;
